/* eslint-disable import/prefer-default-export */

export const breakpoints = {
  small: 414,
  medium: 600,
  large: 1100,
  maxWidth: 1200,
};
